import { render, staticRenderFns } from "./ShowImageAndUpLoad.vue?vue&type=template&id=fc3635a4"
import script from "./ShowImageAndUpLoad.vue?vue&type=script&lang=js"
export * from "./ShowImageAndUpLoad.vue?vue&type=script&lang=js"
import style0 from "./ShowImageAndUpLoad.vue?vue&type=style&index=0&id=fc3635a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports